// extracted by mini-css-extract-plugin
export default {"bubble":"pRupf","icon":"ewcom","text":"Ck324"};